import React from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';
import { ContextMenu } from 'react-contextmenu';
import FontAwesome from 'react-fontawesome';

const ActionButtons = ({
  buttonComponent: ButtonComponent,
  containerComponent: ContainerComponent,
  containerId,
  onDeleteEventClick,
  onEditEventClick,
  onOpenClick,
  onPrintWorkOrder,
  showLabels,
  onContextMenuClick,
  showMenuItem,
  ...props
}) => (
   containerId === 'JOB_MENU' ?
  <ContainerComponent onShow={onContextMenuClick} id={containerId} {...props}>
    {typeof onOpenClick === 'function' && (
      <ButtonComponent  onClick={onOpenClick}>
        <FontAwesome name="external-link" />
        {showLabels && " Open"}
      </ButtonComponent>
    )}
    {typeof onPrintWorkOrder === 'function' && showMenuItem && (
      <ButtonComponent onClick={onPrintWorkOrder}>
        <FontAwesome name="print" />
        {showLabels && " Print Work Order"}
      </ButtonComponent>
    )}
    {typeof onEditEventClick === 'function' && showMenuItem &&(
      <ButtonComponent  onClick={onEditEventClick}>
        <FontAwesome name="pencil" />
        {showLabels && " Edit"}
      </ButtonComponent>
    )}
    {typeof onDeleteEventClick === 'function' && showMenuItem &&(
      <ButtonComponent onClick={onDeleteEventClick}>
        <FontAwesome name="trash-o" />
        {showLabels && " Delete"}
      </ButtonComponent>
    )}
  </ContainerComponent>:
  <ContainerComponent id={containerId} {...props}>
  {typeof onOpenClick === 'function'  && (
    <ButtonComponent  onClick={onOpenClick}>
      <FontAwesome name="external-link" />
      {showLabels && " Open"}
    </ButtonComponent>
  )}
  {typeof onPrintWorkOrder === 'function' && showMenuItem && (
    <ButtonComponent onClick={onPrintWorkOrder}>
      <FontAwesome name="print" />
      {showLabels && " Print Work Order"}
    </ButtonComponent>
  )}
  {typeof onEditEventClick === 'function' && showMenuItem  &&(
    <ButtonComponent  onClick={onEditEventClick}>
      <FontAwesome name="pencil" />
      {showLabels && " Edit"}
    </ButtonComponent>
  )}
  {typeof onDeleteEventClick === 'function' && showMenuItem && (
    <ButtonComponent onClick={onDeleteEventClick}>
      <FontAwesome name="trash-o" />
      {showLabels && " Delete"}
    </ButtonComponent>
  )}
  </ContainerComponent>
)



;

ActionButtons.defaultProps = {
  buttonComponent: Button,
  containerComponent: ButtonToolbar,
  showLabels: false,
  showMenuItem:true
 
};

export default ActionButtons;
